module.exports = __webpack_public_path__ + "static/media/women.161eed58.jpg";